import { Title } from '@ui/components/title'

import { DownloadCard } from '@ui/components/download-card'
//import { Loader } from '@ui/components/loader'
import { useDocuments } from '@hooks/use-documents'
import Loader from '@ui/components/Loader'

const DocumentazioneModal = () => {
	const documents = useDocuments('PREVENTIVO')?.filter(
		(doc) => doc.Tipologia !== 'Privacy'
	)

	return (
		<div className={'documentazione-modal'}>
			<Title className={'documentazione-modal__title'}>
				Altra documentazione Trasparenza
			</Title>
			{!documents && (
				<div className={'documentazione-modal__loader'}>
					<p>Nessun documento è stato trovato</p>
				</div>
			)}
			{documents?.length === 0 ? (
				<div className={'documentazione-modal__loader'}>
					{/* <Loader force /> */}
				</div>
			) : (
				documents?.map((doc) => <DownloadCard key={doc.ID} document={doc} />)
			)}
		</div>
	)
}

export { DocumentazioneModal }
